import { render, staticRenderFns } from "./ZadArLogo.vue?vue&type=template&id=13c8b40a&scoped=true"
import script from "./ZadArLogo.vue?vue&type=script&lang=js"
export * from "./ZadArLogo.vue?vue&type=script&lang=js"
import style0 from "./ZadArLogo.vue?vue&type=style&index=0&id=13c8b40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8b40a",
  null
  
)

export default component.exports